module.exports = __webpack_public_path__ + "img/快哭了.e8832a90.png";